<!--
 *                   江城子 . 程序员之歌
 * 
 *               十年生死两茫茫，写程序，到天亮。
 *                   千行代码，Bug何处藏。
 *               纵使上线又怎样，朝令改，夕断肠。
 * 
 *               领导每天新想法，天天改，日日忙。
 *                   相顾无言，惟有泪千行。
 *               每晚灯火阑珊处，夜难寐，加班狂。
 * 
 * 
 * @Author: ZP
 * @Date: 2024-02-28 14:47:05
 * @FilePath: \project\Disassembly_mobile\src\components\upload\uploads.vue
 * @LastEditors: zp
 * @LastEditTime: 2024-03-12 13:10:00
 -->

<template>
    <div>
        <van-uploader v-model="imageFile" :after-read="uploadershang" :multiple="num>1?true:false" :max-count="num" :before-delete="deleteimg2"></van-uploader>
    </div>
</template>

<script>
import OSS from 'ali-oss';
import {Toast} from 'vant'
    export default {
		props:['num','type'],
        data() {
            return {
                imageFile: [],
            }
        },
		
        methods: {
            deleteimg2(file, datail) {
                this.imageFile.forEach((item, index) => {
                    if (index == datail.index) {   // 判断删除的下标是否正确
                        this.imageFile.splice(index, 1) // 使用遍历找到的index去数组里面删除
						this.$emit('closeArr',index)
                    }
                })
            },
			beforeRead(){
				console.log(arguments)
			},
			uploadershang(file){
		
				file.status = "uploading";
				file.message = "上传中...";
				if (file instanceof Array) {
					file.forEach(item => {
				
						this.upImages(item)

						
					})
				} else {
					this.upImages(file)
				}
			},
			async upImages(file) {
				const client = new OSS({
						region: 'oss-cn-beijing', // 设置地区信息
						accessKeyId: 'LTAI4FvvrPH1RA5smPfXU3sD', // 设置Access Key ID
						accessKeySecret: 'XLB30cBoApxpeuoeYDAmjTsifEPJIw', // 设置Access Key Secret
						bucket: 'cheqidian' // 设置Bucket名称
					});
					var toast = Toast.loading({
						duration: 2000, // 持续展示 toast
						forbidClick: true,
						message: "加载中..."
					});
					try {
						console.log(12313213213213)
						// 生成随机文件名
						const fileName = `${Date.now()}-${file.file.name}`;
						
						// 调用put方法上传文件
						const result = await client.put(`zhb/${fileName}`, file.file);
						console.log(123)
						this.$emit('imagesUrl',{url:result.url,type:this.type})
						toast.clear()//清除加载效果
						file.status = "done";
						// console.log(result,'文件上传成功！');
					} catch (error) {
						file.status = "failed";
						toast.clear()//清除加载效果
						// console.error('文件上传失败：', error);
					}
			},
			//修改
            setChange(img){
				this.imageFile = []
				if(img instanceof Array){
					for(let i=0;i<img.length;i++){
						this.imageFile.push({url:img[i]})
					}
				}else{
					this.imageFile = [{url:img}]
				}
				
				
			}
        },
    }
</script>

<style lang="scss" scoped>

</style>